import React from "react"
import PropTypes from "prop-types"
import DOMPurify from "dompurify"

// Style
import { BasicTextContainer, Text, Label } from "Components/chartsLibrary/BasicTextV2/index.style"

const BasicTextV2 = ({
  basicTextLabelAlignement,
  basicTextTextAlignement,
  basicTextTextColor,
  basicTextTextSize,
  activeBackground,
  backgroundColor,
  textAreaValue,
  labelWeight,
  labelColor,
  labelSize,
  label,
}) => {
  const sanitizedHTML = DOMPurify.sanitize(textAreaValue)

  return (
    <BasicTextContainer
      fontAlignement={basicTextLabelAlignement}
      backgroundColor={backgroundColor}
      activeBackground={activeBackground}
    >
      <Label labelColor={labelColor} labelSize={labelSize} labelWeight={labelWeight}>
        {label || ""}
      </Label>
      {textAreaValue.length > 0 && (
        <Text
          basicTextAlignement={basicTextTextAlignement}
          basicTextSize={basicTextTextSize}
          basicTextColor={basicTextTextColor}
          backgroundColor={backgroundColor}
          activeBackground={activeBackground}
          dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
          readOnly
          className={"stylePersonalized"}
        />
      )}
    </BasicTextContainer>
  )
}

BasicTextV2.propTypes = {
  basicTextLabelAlignement: PropTypes.string,
  basicTextTextAlignement: PropTypes.string,
  basicTextTextColor: PropTypes.string,
  basicTextTextSize: PropTypes.string,
  backgroundColor: PropTypes.string,
  activeBackground: PropTypes.bool,
  textAreaValue: PropTypes.string,
  labelWeight: PropTypes.string,
  labelColor: PropTypes.string,
  labelSize: PropTypes.string,
  label: PropTypes.string,
}

BasicTextV2.defaultProps = {
  basicTextLabelAlignement: "",
  basicTextTextAlignement: "",
  activeBackground: true,
  basicTextTextColor: "",
  basicTextTextSize: "",
  backgroundColor: "",
  textAreaValue: "",
  labelWeight: "",
  labelColor: "",
  labelSize: "",
  label: "",
}

export default BasicTextV2
